<template>
    <div>
        <Card
            title="Manage Site"
            read="Refresh"
            @read="load()"
            @write="save()"
            write="Apply"
            alwaysShow
        >
            <b-form-checkbox v-model="mutatedSite.register" size="lg" switch>
                Register
            </b-form-checkbox>
            <b-form-checkbox v-model="mutatedSite.login" size="lg" switch>
                Login
            </b-form-checkbox>
            <b-form-checkbox v-model="mutatedSite.access" size="lg" switch>
                Access
            </b-form-checkbox>
            <hr />
            <h5>Domain blacklist</h5>
            <ArrayTextArea v-model="mutatedSite.blacklistDomains" />
            <h5 class="mt-3">Keyword blacklist</h5>
            <ArrayTextArea v-model="mutatedSite.blacklistKeywords" />
            <hr />
            <h5>Referral Credits</h5>
            <Input
                text="Referer"
                type="number"
                v-model="mutatedSite.refererCredit"
                :append="mutatedSite.refererCredit | formatCurrency"
            />
            <Input
                text="Referee"
                type="number"
                v-model="mutatedSite.refereeCredit"
                :append="mutatedSite.refereeCredit | formatCurrency"
            />
        </Card>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import ArrayTextArea from '@/components/form/arraytextarea'
    import Card from '@/components/general/card'
    import Input from '@/components/form/input'

    export default {
        data() {
            return {
                mutatedSite: {}
            }
        },
        methods: {
            load() {
                return this.$store.dispatch('admin/site/load').then(() => {
                    this.mutatedSite = { ...this.site }
                })
            },
            save() {
                return this.$store
                    .dispatch('admin/site/save', this.mutatedSite)
                    .then(() => {
                        this.$bvToast.toast('Site settings saved.', {
                            title: 'Success',
                            variant: 'success'
                        })
                        this.mutatedSite = { ...this.site }
                    })
            }
        },
        computed: mapState({
            site: state => state.admin.site.site
        }),
        components: {
            ArrayTextArea,
            Card,
            Input
        }
    }
</script>

<style scoped></style>
